// CPP and PATIENT_ASSISTANCE
export const SET_FAJITA_QUESTIONNAIRE_FORM = 'FormsGlobalContext.SET_FAJITA_QUESTIONNAIRE_FORM';